import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    marginLeft: 0,
    marginTop: "20px",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: 0,
    paddingRight: 0,
    maxWidth: "500px",
    marginBottom: "80px",
  },
  spacing: {
    padding: "20px",
  },
  section: {
    marginBottom: "20px",
    borderRadius: "8px",
  },
  activationSection: {},
  bottomBorder: {
    "&:after": {
      position: "absolute",
      bottom: "8px",
      left: 0,
      right: 0,
      height: "1px",
      content: "",
      backgroundColor: theme.palette.gray.light,
    },
  },
  highlight: {
    animation: "$highlightPaper 1 5s linear",
  },
  spinner: {
    marginLeft: "10px",
  },
  split: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
  },
  splitHorizontallyCentered: {
    alignItems: "center",
  },
  description: {
    paddingTop: "5px",
    fontWeight: 100,
    lineHeight: "18px",
  },
  descriptionSpacingBottom: {
    marginBottom: "25px",
  },
  infoBox: {
    padding: "10px",
    display: "flex",
    backgroundColor: theme.palette.gray.light,
    borderRadius: "5px",
    marginTop: "15px",
    marginBottom: "25px",
    alignItems: "center",
  },
  infoBoxText: {
    paddingLeft: "15px",
  },
  darkIcon: {
    display: "flex",
    color: "black",
  },
  inputContainer: {
    marginBottom: "20px",
  },
  actionContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  actionButton: {
    "&:not(:first-child)": {
      marginInlineStart: "10px",
    },
  },
  readonlyField: {
    "&:not(:last-child)": {
      marginBottom: "20px",
    },
  },
  bottomSpacedText: {
    paddingBottom: "5px",
    wordBreak: "break-all",
  },
  headSpace: {
    marginTop: "10px",
  },
  samlSampleButton: {
    marginTop: "10px",
    marginBottom: "30px",
  },
  "@keyframes highlightPaper": {
    "0%": {
      boxShadow: "0 1px 8px rgba(255, 208, 36, 0.6)",
    },
    "70%": {
      boxShadow: "0 1px 8px rgba(255, 208, 36, 0.6)",
    },
    "100%": {
      boxShadow: "0 1px 8px transparent",
    },
  },
}));
